// ————————————————————————————————————————————— LIB. ————————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

// ...

// ———————————————————————————————————————————— UTIL. ————————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

// ...

// ———————————————————————————————————————— EVENT HANDLERS ———————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

// ...

// ———————————————————————————————————————————— ASSETS ———————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

// ...

// —————————————————————————————————————— INIT. METHOD DEF. ——————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

export default function init_gateway() {
  //////////////////////////////////////////// Setup /////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////

  const fullpageMod = this.modules.fullpage;
  const { btn_gateway_bewerben, btn_gateway_allgemein } = this.ref;

  //////////////////////////////////////////// ACTION ////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////

  // Gateway btns. init. //
  if (btn_gateway_bewerben) {
    btn_gateway_bewerben.addEventListener("click", () => {
      this.setState({ gatewayOpen: true });
      fullpage_api.moveTo(btn_gateway_bewerben.dataset.target);
      this.setState({ gatewayOpen: false });
    });
  }

  if (btn_gateway_allgemein) {
    btn_gateway_allgemein.addEventListener("click", () => {
      this.setState({ gatewayOpen: true });
      // fullpage_api.moveTo(btn_gateway_allgemein.dataset.target);
      fullpageMod.scrollToElement(`[data-id="${btn_gateway_allgemein.dataset.target}"]`, "bewerben", { offset: 0 });
      this.setState({ gatewayOpen: false });
    });
  }

  // Init. gateway-open state //
  this.setState({ gatewayOpen: false });

  /////////////////////////////////////////// Conclude ///////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////

  // ...
}

// ———————————————————————————————————————————————————————————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //
